<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <h4>{{ $t('message.trialtipprefix') + viewNumber + $t('message.trialtipsuffix') }}</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('message.closebtn') }}</button>
          <button type="button" class="btn btn-primary" @click="confirm">{{ $t('message.confirmbtn') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  data() {
    return {
    }
  },
  computed: {
    isPork() {
      return this.$route.path.includes('Pork') || this.$route.path.includes('PTC')
    },
    viewNumber() {
      return this.$store.getters.newsPermission.viewNum
    },
    articleid() {
      return this.$store.getters.newsPermission.articleid
    },
    isEN() {
      return this.$i18n.locale === 'en'
    },
    path() {
      if (this.isPork) {
        return this.isEN ? `/Pork/English/PorkArticle/${this.articleid}` : `/Pork/PorkArticle/${this.articleid}`
      } else {
        return this.isEN ? `/english/article/${this.articleid}` : `/article/${this.articleid}`
      }
    }
  },
  methods: {
    confirm() {
      $('#trialModel').modal('hide')
      this.$router.push(this.path)
    }
  }
}
</script>
<style scoped>
.modal {
  top: 15%;
}
</style>



// WEBPACK FOOTER //
// src/components/TrialDialog/index.vue